// 매장 정지 상태 감지 hook (P0-2)
// 5분마다 폴링 + API 호출 시 403 STORE_SUSPENDED 응답 감지
import { useEffect, useState } from 'react'
import { supabase } from '@/lib/supabase'
import { useAuthStore } from '@/store/authStore'

export function useSuspensionCheck() {
  const user = useAuthStore((s) => s.user)
  const [isSuspended, setIsSuspended] = useState(false)
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    if (!user) {
      setIsSuspended(false)
      setChecked(true)
      return
    }

    let active = true

    const check = async () => {
      try {
        const { data } = await supabase
          .from('stores')
          .select('subscription_status')
          .eq('id', user.id)
          .single()
        if (!active) return
        const status = (data as { subscription_status?: string } | null)?.subscription_status
        setIsSuspended(status === 'suspended')
      } catch {
        // ignore — graceful degradation
      } finally {
        if (active) setChecked(true)
      }
    }

    void check()
    // 5분 폴링
    const id = setInterval(check, 5 * 60 * 1000)

    // 백엔드에서 403 STORE_SUSPENDED 응답이 오면 즉시 갱신
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail
      if (detail?.code === 'STORE_SUSPENDED') setIsSuspended(true)
    }
    window.addEventListener('cafe-brain:suspended', handler)

    return () => {
      active = false
      clearInterval(id)
      window.removeEventListener('cafe-brain:suspended', handler)
    }
  }, [user])

  return { isSuspended, checked }
}
